import { UISref } from "@uirouter/react";
import { noop } from "lodash";
import { FunctionComponent, useContext, useMemo } from "react";
import { PrimaryButton } from "../../../../../components/button";
import { KycIcon } from "../../../../../components/icons/status";
import { Table } from "../../../../../components/table";
import { VerificationDTO } from "../../../../../store/verification/models/dto/due-diligence";
import { useDueDiligenceKycType } from "../../../../../store/verification/models/internal";
import { VerificationService } from "../../../../../store/verification/service";
import { FraudRoutes } from "../../../../kyc-kyb-aml/routes";
import { ConfigContext } from "../../public/common/config-context";
import { StyledWidget } from "./common";

interface IParticipantsProps {
  participants: VerificationDTO.Responses.DueDiligence.Form.Get.T["participants"];
  kycs: VerificationDTO.Responses.DueDiligence.Form.Get.T["kycs"];
  configId: VerificationDTO.Responses.DueDiligence.Config.Get.T["id"];
}

const Participants: FunctionComponent<IParticipantsProps> = ({
  participants,
  kycs,
  configId,
}) => {
  const dueDiligenceType = useDueDiligenceKycType();

  const items = useMemo(
    () => [
      ...participants
        .filter(
          (x) =>
            !kycs.find((y) => y.details.user.emailAddress === x.emailAddress)
        )
        .map((x) => ({
          firstName: x.firstName,
          lastName: x.lastName,
          types: [],
          fraudCheckId: x.id,
          status: undefined,
        })),
      ...kycs.map((x) => ({
        firstName: x.details.user.firstName,
        lastName: x.details.user.lastName,
        types: x.types.map((f) => dueDiligenceType.enum[f]).join(" / "),
        fraudCheckId: x.details.fraudCheckId,
        status: x.details.userStatus,
      })),
    ],
    [participants, kycs]
  );
  return (
    <StyledWidget title="Participants">
      <Table
        data={items}
        head={[
          {
            name: "firstName",
            title: "First Name",
          },
          {
            name: "lastName",
            title: "Last Name",
          },
          {
            name: "types",
            title: "Types",
          },
          {
            name: "status",
            title: "KYC Status",
            centered: true,
          },
          {
            name: "fraudCheckId",
            title: "",
            centered: true,
          },
        ]}
        unsortable={[
          "firstName",
          "lastName",
          "types",
          "status",
          "fraudCheckId",
        ]}
        renderFields={{
          fraudCheckId: ({ fraudCheckId, status }) =>
            status ? (
              <UISref
                to={FraudRoutes.names.singleIndividualKyc}
                params={{ fraudCheckId }}
              >
                <a>
                  <PrimaryButton variant="contained">View KYC</PrimaryButton>
                </a>
              </UISref>
            ) : (
              <PrimaryButton
                onClick={() =>
                  VerificationService.resendEmailToParticipant(
                    configId,
                    fraudCheckId
                  ).catch(noop)
                }
              >
                Resend E-mail
              </PrimaryButton>
            ),
          status: ({ status }) =>
            status ? (
              <div style={{ display: "inline-block" }}>
                {KycIcon(status, "kyc")}
              </div>
            ) : null,
        }}
      />
    </StyledWidget>
  );
};

export default Participants;
